import React, { JSX, ReactNode } from 'react';
import classNames from 'classnames';

import Modal, { ModalProps } from '../../atoms/modal/Modal';
import Text from '../../atoms/text/Text';
import { Button, ButtonProps } from '../../atoms/button';

interface ModalButtonProps extends ButtonProps {
  label?: string;
}

interface ConfirmationModalType extends ModalProps {
  iconComponent?: JSX.Element | ReactNode;
  title: string;
  subTitle?: string;
  cancelButton?: ModalButtonProps;
  confirmButton: ModalButtonProps;
}

export default function ConfirmationModal({
  iconComponent,
  title,
  subTitle,
  isOpen,
  portal,
  closeAble = true,
  overlay = true,
  onClose,
  cancelButton,
  confirmButton = {
    fill: 'fill',
    type: 'info',
  },
}: ConfirmationModalType) {
  return (
    <Modal
      isOpen={isOpen}
      portal={portal}
      closeAble={closeAble}
      overlay={overlay}
      onClose={onClose}
    >
      <div className="p-12">
        {iconComponent}
        <div className="mt-10 pre-line">
          <Text
            size="lg"
            weight="semibold"
            className="text-break"
            color="title"
            component="h2"
          >
            {title}
          </Text>
          <Text size="sm" color="subtitle2 pre-line">
            {subTitle}
          </Text>
        </div>
        <div className="d-flex justify-content-center gap-8 mt-16">
          {cancelButton && (
            <Button
              className={classNames('flex-fill', {
                [cancelButton?.className]: cancelButton?.className,
              })}
              {...cancelButton}
            >
              {cancelButton?.label ? cancelButton?.label : 'Cancel'}
            </Button>
          )}
          <Button
            className={classNames('flex-fill', {
              [confirmButton?.className]: confirmButton?.className,
            })}
            {...confirmButton}
          >
            {confirmButton?.label ? confirmButton?.label : 'Confirm'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
